import { render, staticRenderFns } from "./archivesCenter.vue?vue&type=template&id=fe88407a&scoped=true"
import script from "./archivesCenter.vue?vue&type=script&lang=js"
export * from "./archivesCenter.vue?vue&type=script&lang=js"
import style0 from "./archivesCenter.vue?vue&type=style&index=0&id=fe88407a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe88407a",
  null
  
)

export default component.exports